module.exports = __webpack_public_path__ + "static/media/MG动画.e92ed10.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MG动画.mp4
// module id = Say/
// module chunks = 3